import { forConversation } from '../channels';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';
import { DIALOGUE_INPUT } from './topics';

export const FINISH = 'DIALOGUE/FINISH';

export type EndConversationReasons =
  | 'error'
  | 'operator-finished'
  | 'bot-finished'
  | 'visitor-bell'
  | 'operator-bell'
  | 'visitor-response-timeout'
  | 'operator-claim-timeout'
  | 'no-operators-online'
  | 'operator-response-timeout'
  | 'dialogue-timeout'
  | 'vocalisation-timeout'
  | 'voice-to-text-timeout';

export const endConversationReasonsSchema = Joi.string().valid(
  'error',
  'operator-finished',
  'bot-finished',
  'visitor-bell',
  'operator-bell',
  'visitor-response-timeout',
  'operator-claim-timeout',
  'no-operators-online',
  'operator-response-timeout',
  'dialogue-timeout',
  'vocalisation-timeout',
  'voice-to-text-timeout'
);

export interface IEndConversationPayload {
  conversationId: string;
  reason: EndConversationReasons;
  description?: string;
}

export interface IEndConversationParams {
  conversationId: string;
  reason: EndConversationReasons;
  description?: string;
}

export const endConversationPayloadSchema = objectSchemaOf<IEndConversationPayload>(
  {
    conversationId: Joi.string().required(),
    reason: endConversationReasonsSchema.required(),
    description: Joi.string().optional(),
  }
);

export const endConversationParamsSchema = endConversationPayloadSchema;

export const endConversationActionSchema = objectSchemaOf<IEndConversationAction>(
  {
    type: Joi.string().required().valid(FINISH),
    payload: endConversationPayloadSchema.required(),
  }
);

export interface IEndConversationAction {
  type: typeof FINISH;
  payload: IEndConversationPayload;
}

export const endConversation = actionCreator({
  type: FINISH,
  schema: endConversationActionSchema,
  topic: DIALOGUE_INPUT,
  channels: [forConversation],
});
